import React, { useEffect } from "react"
import intl from "react-intl-universal"
import FileIcon from "../../../../../assets/icons/CIQIcon"
import ContentBlank from "../../../../molecules/ContentBlank"
import styles from "./index.module.scss"

import RcmpHeader from "../../../../atoms/Header"
import initialStateListAnalytesImage from "../../../../../assets/icons/InitialStateListAnalytesImage.svg"
import PlusIcon from "../../../../../assets/icons/PlusIcons"
import { ModalCreateAnalito } from "../../ModalCreateAnalito"
import RcmpEmptyContentPage from "../../../../molecules/EmptyContentPage"
import { Table } from "../../../../molecules/Table"
import { listAnalytesCreated } from "../../../../../services/ciq"
import RcmpLoading from "../../../../atoms/Loading"
import InfiniteScroll from "../../../../atoms/InfiniteScroll"
import { ModalEditAnalite } from "../../ModalEditAnalite"
import "./style.css"
import { toast } from "@stardust-ds/react"
import { fnCanAtLeast } from "../../../../../utils/permissions"
import { fnisOnlyPermition } from "../../../../../utils/verifyPermitions"
import { useNavigate } from "react-router-dom"
import {
  fnIsAccessPermition,
} from "../../../../../utils/verifyPermitions"

const ListAnalytes = () => {
  const [bIsOpenModal, setBisOpenModal] = React.useState(false)
  const [bIsOpenModalEdit, setEditModal] = React.useState(false)
  const [listAnalytes, setListAnalytes] = React.useState([])
  const [updateList, setUpdateList] = React.useState(false)
  const [infoInfititeScroll, setInfoInfititeScroll] = React.useState({})
  const [nPage, setNPage] = React.useState(1)
  const [cName, setCname] = React.useState("")
  const [bStatus, setBStatus] = React.useState("&anlt_bstatus=1")
  const [orderFieldAndOrder, setOrderFieldAndOrder] = React.useState("")
  const [analyteId, setAnalyteId] = React.useState("")
  const [loadingInnerTable, setLoadingInnerTable] = React.useState(true)

  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      path: "/ciq",
      name: intl.get("ciq.title"),
    },
    {
      name: intl.get("ciq.list_analytes.exame_analyte"),
      bActive: true,
    },
  ]

  const fnGetListAnalytes = async (npage, cname, status, order) => {
    if (loadingInnerTable && listAnalytes?.length > 0) return
    try {
      setLoadingInnerTable(true)
      const response = await listAnalytesCreated(npage, cname, status, order)

      const newData = response.data.data.data
        .map((item) => {
          return {
            anlt_cname: item.anlt_cname,
            anlt_type: item.anlt_type,
            anlt_sector: item.anlt_sector?.sector_cname,
            anlt_bstatus: item.anlt_bstatus
              ? intl.get("ciq.list_analytes.active")
              : intl.get("ciq.list_analytes.inactive"),
            anlt_nid: item.anlt_nid,
          }
        })
        .map((item) => {
          if (item.anlt_type === "Quantitativo") {
            return { ...item, anlt_type: intl.get("ciq.types_analytes.quantitative") }
          } else if (item.anlt_type === "Qualitativo") {
            return { ...item, anlt_type: intl.get("ciq.types_analytes.qualitative") }
          } else {
            return {
              ...item,
              anlt_type: intl.get("ciq.types_analytes.semmi_quantitative"),
            }
          }
        })

      setInfoInfititeScroll({
        last_page: response.data.data.last_page,
      })

      if (npage <= 1) {
        setListAnalytes(newData)
        return
      }

      setListAnalytes((prev) => [...prev, ...newData])
    } catch (err) {
      toast.error({
        title: intl.get("ciq.list_analytes.error_loading_analytes"),
      })
    } finally {
      setLoadingInnerTable(false)
    }
  }

  function fnNextPage(page) {
    setNPage(page)
  }

  useEffect(() => {
    setNPage(1)
    fnGetListAnalytes(1, cName, bStatus, orderFieldAndOrder)
  }, [updateList, cName, bStatus, orderFieldAndOrder])

  useEffect(() => {
    if (nPage <= 1) return
    fnGetListAnalytes(nPage, cName, bStatus, orderFieldAndOrder)
  }, [nPage])

  useEffect(() => {
    if (!fnCanAtLeast("access-ciq", "internal-quality-control")) {
      window.location.href = "/"
      return
    }
  }, [])

  const isAccessCreateAndEditAnalyte = fnIsAccessPermition("create-edit-analyte")

  const isPermition = fnisOnlyPermition("access-ciq") || !isAccessCreateAndEditAnalyte

  return (
    <div>
      <RcmpHeader
        elIcon={<FileIcon />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={aBreadCrumbs}
        className={styles.header}
      ></RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bArrowLeftGoBack={true}
        bVisibleIconSearch
        bSwitchAtive={true}
        cWidthBtn={"15rem"}
        cIconLeftInsideBtn={<PlusIcon />}
        cPathGoBack={"/ciq"}
        cLabelGoBack={intl.get("ciq.list_analytes.exame_analyte")}
        className={styles.contentB1lankCustom}
        sButtonLabel={intl.get("ciq.list_analytes.add_exame_analyte")}
        bDisableButton={isPermition}
        fnSetBisOpenModal={() => {
          if (isPermition) return
          setBisOpenModal(true)
        }}
        fnOnChangeSwitch={(e) => {
          const status = e().bDone

          setBStatus(status ? "" : "&anlt_bstatus=1")
        }}
        bValueSwitch={bStatus === "&anlt_bstatus=1" ? false : true}
        setSearchTerm={(e) => {
          setCname(!e ? "" : `&search_text=${e.toLowerCase()}`)
        }}
        bHasVideoTutorial={false}
      >
        {listAnalytes?.length === 0 && !loadingInnerTable && (
          <div className={styles.wrapperListAnalytes}>
            <RcmpEmptyContentPage
              bShow={true}
              cMessage={
                cName === ""
                  ? intl.get("ciq.list_analytes.any_exames")
                  : intl.get("ciq.list_analytes.analyte_not_found_search")
              }
              cActionMessage={intl.get("ciq.list_analytes.new_analyte")}
              fnOnAction={() => setBisOpenModal(true)}
              cQuestion={intl.get("ciq.what_is_analyte")}
              cAnswer={intl.get("ciq.analyte_answer")}
              image={initialStateListAnalytesImage}
            />
          </div>
        )}
        <InfiniteScroll
          fnNext={fnNextPage}
          nTotalPages={infoInfititeScroll.last_page}
          nDataLength={listAnalytes?.length || 0}
          bStopPagination={loadingInnerTable}
          bResetPage={nPage === 1}
        >
          <Table
            isPermition={!isAccessCreateAndEditAnalyte}
            bNotShowIfEmpty={true}
            thead={[
              intl.get("ciq.header_table_list_analyte.name"),
              intl.get("ciq.header_table_list_analyte.type"),
              intl.get("ciq.header_table_list_analyte.sector"),
              intl.get("ciq.header_table_list_analyte.status"),
              intl.get("ciq.header_table_list_analyte.action"),
            ]}
            tbodyArray={listAnalytes}
            cursorNormal
            fnOrder={(sort_field, sort_order) => {
              if (sort_field.includes("sector")) {
                setOrderFieldAndOrder(`&sort_field=sector_cname&sort_order=${sort_order}`)
                return
              }
              setOrderFieldAndOrder(`&sort_field=${sort_field}&sort_order=${sort_order}`)
            }}
            handleClickSettings={(ev) => {
              setAnalyteId(ev.anlt_nid)
              setEditModal(true)
            }}
            load={!listAnalytes?.length && loadingInnerTable}
            loadingInnerTable={nPage <= 1 && loadingInnerTable}
          />
          {loadingInnerTable && nPage > 1 && (
            <RcmpLoading bShow={true} size={50} className={styles.loading} />
          )}
        </InfiniteScroll>
      </ContentBlank>
      {bIsOpenModal && (
        <ModalCreateAnalito onClose={setBisOpenModal} setUpdateList={setUpdateList} />
      )}

      {bIsOpenModalEdit && (
        <ModalEditAnalite
          onClose={setEditModal}
          setUpdateList={setUpdateList}
          analyteId={analyteId}
        />
      )}
    </div>
  )
}
export default ListAnalytes
